'use client';
import React from 'react';
import { Modal } from '@mui/material';
import { ModalWindowProps as Props } from './model.type';
import { IconClose } from '@components/SVGIcon/Icons';
import cn from './Model.style.module.scss';

export function ModalWindow(props: Props & { closeIconClassName?: string }) {
  const [close, setClose] = React.useState(false);
  React.useEffect(() => {
    const lenis = (window as any).globalLenis;
    if (!lenis) return;
    if (props.isOpen) {
      lenis.stop();
    } else {
      lenis.start();
    }
    return () => {
      if (props.isOpen) (window as any).globalLenis?.start();
    };
  }, [props.isOpen]);
  const startClose = (e?: any) => {
    setClose(true);
    setTimeout(() => {
      if (props.onClose) (props.onClose as any)(e);
      setClose(false);
    }, 500);
  };

  const handleMuiClose = (
    event: object,
    reason: 'backdropClick' | 'escapeKeyDown'
  ) => {
    startClose(event);
  };

  const onClickModal = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const closeIconClass = [cn.modalCloseIcon, (props as any).closeIconClassName]
    .filter(Boolean)
    .join(' ');

  const renderedCloseIcon = props.closeIcon ? (
    React.isValidElement(props.closeIcon) ? (
      React.cloneElement(props.closeIcon as React.ReactElement, {
        className: [(props.closeIcon as any).props?.className, closeIconClass]
          .filter(Boolean)
          .join(' '),
        onClick: (e: React.MouseEvent) => {
          startClose(e);
          const originalOnClick = (props.closeIcon as any).props?.onClick;
          if (typeof originalOnClick === 'function') originalOnClick(e);
        },
      })
    ) : (
      props.closeIcon
    )
  ) : (
    <span
      className={closeIconClass}
      onClick={(e) => startClose(e)}
      data-testid="close-icon"
      role="button"
      aria-label="Close"
    >
      <IconClose />
    </span>
  );

  return (
    <Modal
      open={props.isOpen}
      className={`${cn.customModal} ${close ? cn.modalClose : cn.modalOpen} ${
        props.wrapperClassName ?? ''
      }`}
      onClose={handleMuiClose}
    >
      <div
        className={`${cn.modalBlock} ${
          close ? cn.contentClosed : cn.contentOpen
        } ${props.className ?? ''}`}
        onClick={onClickModal}
        data-testid="modal-content"
      >
        {props.closeElement}
        {!props.hideHeader && props.title && (
          <div className={cn.headerContainer}>
            <p className={cn.headerContainer__title}>{props.title}</p>
          </div>
        )}

        {props.close && renderedCloseIcon}

        {props.children}
      </div>
    </Modal>
  );
}
